import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemText,
  styled,
} from "@mui/material";
import React, { Fragment, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { colors } from "../../utils/Colors/Colors";
import { RoutesPath } from "../../routes/RoutesPath";
import { Link as ScrollLink } from "react-scroll";

const SideDrawer = ({ open = false, handleClose = () => null }) => {
  const navigation = useNavigate();
  const location = useLocation().pathname;

  const list = [
    { name: "Home", navigate: "home" },
    { name: "Features", navigate: "feature" },
    { name: "Pricing", navigate: "plans" },
    { name: "FAQ", navigate: "faq" },
    { name: "Contact", navigate: "contact" },
  ];

  const handleNavigation = (navigateTo) => {
    if (["home","plans", "feature", "faq", "contact"].includes(navigateTo)) {
      document.getElementById(navigateTo)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (navigateTo && location !== navigateTo) {
      navigation(navigateTo);
    }
    handleClose(); // Close the drawer after navigation
  };

  return (
    <Drawer anchor="right" open={open} onClose={handleClose}>
      <List>
        {list.map((item, index) => (
          <Fragment key={index}>
            <ListItem button onClick={() => handleNavigation(item.navigate)}>
              <ListItemText
                primary={item.name}
                sx={{ color: colors.black }}
                component={
                  ["plans", "feature", "faq", "contact"].includes(item.navigate)
                    ? ScrollLink
                    : Link
                }
                to={item.navigate}
                smooth={true}
                offset={-70}
              />
            </ListItem>
            <Divider />
          </Fragment>
        ))}
      </List>
    </Drawer>
  );
};

const AccordionEdit = styled(Accordion)(() => ({
  "&::before": {
    display: "none",
  },
}));

export default SideDrawer;
